<template>
  <section>
    <b-overlay :show="loading" rounded="sm">
      <div class="info-header mt-2">{{ $t("NAME") }}</div>

      <b-form-input trim :placeholder="$t('NAME')" v-model="name" :state="stateName"  v-on:keypress="isLettersAndNumbers($event)"></b-form-input>

      <div class="mt-2 error-text" v-if="!isValidText">
        {{ $t("ERROR.CHARACTERS_NOT_ALLOWED") }} {{  notAllowedCharacters }}
      </div>

      <div class="mt-2 error-text" v-if="name.length > 256">
        {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
      </div>
      <div class="text-right">
        <small class="pull-right">{{ name.length }}/256</small>
      </div>


      <b-form-textarea
        class="mt-2 textarea"
        id="messageContent"
        input-id="message"
        ref="messageContent"
        v-model="content"
        autocomplete="off"
        :placeholder="$t('CONTENT')"
        rows="15"
        :state="content.length <= 20000"
        max-rows="15"
      ></b-form-textarea>
      <div class="mt-2 error-text" v-if="content.length > 20000">
        {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
      </div>
      <div class="text-right">
        <small class="pull-right">{{ content.length }}/20000</small>
      </div>

      <hr class="p-0 m-0 mt-2 mb-2" />

      <b-button @click="cancelBtn">{{ $t("CLOSE") }}</b-button>

      <b-button
        :disabled="addDisabled"
        @click="addBtn"
        id="addBtn"
        variant="primary"
        class="btn-fill"
        >{{ $t("SAVE") }}</b-button
      >
    </b-overlay>
  </section>
</template>
<script>
//import * as blobUtil from "blob-util";
export default {
  components: {},
  props: {    
    folder_uuid: {
      default: "",
      type: String,
    },
    user_uuid: {
      default: "",
      type: String,
    }
  },
  data() {
    return {
      name: "",
      content: "",
      loading: false,
    };
  },
  methods: {
    cancelBtn() {
      this.name = "";
      this.$emit("closeAddNote");
    },
    async addBtn() {
      this.loading = true;
      var dataBlob = new Blob([this.content], { type: "text/plain" });
      let file = new File([dataBlob], this.name + ".txt");
      let formData = new FormData();
      formData.append("file", file);
      formData.append("name", file.name);
      formData.append("folder_uuid", this.folder_uuid);
      formData.append("user_uuid", this.user_uuid);
      let self = this;
      this.$http
        .post(this.user.hostname + "/filestorage/file/add", formData)
        .then(() => {
          self.$emit("addedNote");
        })
        .catch(() => {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_ADD"));
        });
    },
  },
  computed: {
    addDisabled() {
      return this.name == "" || this.name.includes(".") || this.name.length > 256 || !this.validateLettersAndNumbers(this.name);
    },
    isValidText(){
      return this.name == "" || this.validateLettersAndNumbers(this.name);
    },
    stateName(){
      if(this.name == "")
      {
        return null;
      }
      return !this.addDisabled;
    }  
  },
};
</script>
<style>
</style>
